import React from 'react';

import { Typography } from '@sravni/react-design-system';

import headImg from '../imgs/head.png';

import styles from './styles.module.scss';

export const ProposalHead = () => {
  return (
    <div className={styles.container}>
      <Typography.Heading level={1} className={styles.title}>
        Предложи статью для Сравни
      </Typography.Heading>
      <img alt="head-img" className={styles.img} src={headImg} />
    </div>
  );
};
